const CarouselModule = (function () {
    let animationConfig = {
        type: "zoom", // 'slide', 'fade', 'zoom', 'scale-slide'
        duration: 0.6,
        ease: "power3.out",
        autoplay: true,
        autoplayInterval: 9000,
    };

    function setCarouselAnimation(options) {
        animationConfig = { ...animationConfig, ...options };
        resetAutoplay(); // Needs access to resetAutoplay
        console.log("Carousel animation updated:", animationConfig);
    }

    function initCarousel($container) {
        const $carousel = $container.find(".carousel");
        const $slides = $carousel.find(".carouselSlide");
        const slideCount = $slides.length;
        let currentIndex = 0;
        let autoplayTimer;

        const isAbsoluteMode = ["fade", "zoom"].includes(animationConfig.type);

        $carousel.css({
            position: "relative",
            width: "100%",
            height: "100%",
            touchAction: "pan-y",
        });

        $slides.each(function (i) {
            $(this).css({
                position: isAbsoluteMode ? "absolute" : "relative",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: isAbsoluteMode ? (i === 0 ? 2 : 1) : 0,
                opacity: isAbsoluteMode ? (i === 0 ? 1 : 0) : 1,
                transform: "scale(1)",
            });
        });

        const $pagination = $container.find(".carouselPagination").empty();
        for (let i = 0; i < slideCount; i++) {
            const $dot = $("<li>").on("click", () => goToSlide(i));
            if (i === 0) $dot.addClass("active");
            $pagination.append($dot);
        }

        function updatePagination() {
            $pagination
                .find("li")
                .removeClass("active")
                .eq(currentIndex)
                .addClass("active");
        }

        function goToSlide(index) {
            if (index === currentIndex || index < 0 || index >= slideCount) return;

            const $current = $slides.eq(currentIndex);
            const $next = $slides.eq(index);

            $container
                .find(".carouselPagination, .carouselNavigaiton")
                .css("z-index", 10);

            switch (animationConfig.type) {
                case "fade":
                    $current.css("z-index", 1);
                    $next.css("z-index", 2);
                    gsap.to($current, {
                        opacity: 0,
                        duration: animationConfig.duration,
                        ease: animationConfig.ease,
                    });
                    gsap.fromTo(
                        $next,
                        { opacity: 0 },
                        {
                            opacity: 1,
                            duration: animationConfig.duration,
                            ease: animationConfig.ease,
                        }
                    );
                    break;

                case "zoom":
                    $current.css("z-index", 1);
                    $next.css("z-index", 2);
                    gsap.to($current, {
                        scale: 0.9,
                        opacity: 0,
                        duration: animationConfig.duration,
                        ease: animationConfig.ease,
                    });
                    gsap.fromTo(
                        $next,
                        { scale: 1.4, opacity: 0 },
                        {
                            scale: 1,
                            opacity: 1,
                            duration: animationConfig.duration,
                            ease: animationConfig.ease,
                        }
                    );
                    break;

                case "slide":
                default:
                    gsap.to($carousel, {
                        xPercent: -index * 100,
                        duration: animationConfig.duration,
                        ease: animationConfig.ease,
                    });
                    break;
            }

            currentIndex = index;
            updatePagination();
            resetAutoplay();

            // Lazy-load
            const $imgs = $next.find('img');

            $imgs.each(function () {
                const $img = $(this);

                const dataSrc = $img.data('src');

                if (dataSrc) {
                    $img.attr("src", dataSrc);
                    $img.closest(".carouselSlide").addClass("loaded").removeClass("lazy-load-wrapper");
                    $img.removeAttr("data-src");
                }
            });
        }

        function nextSlide() {
            goToSlide((currentIndex + 1) % slideCount);
        }

        function prevSlide() {
            goToSlide((currentIndex - 1 + slideCount) % slideCount);
        }

        function startAutoplay() {
            if (animationConfig.autoplay) {
                clearInterval(autoplayTimer);
                autoplayTimer = setInterval(
                    nextSlide,
                    animationConfig.autoplayInterval
                );
            }
        }

        function resetAutoplay() {
            clearInterval(autoplayTimer);
            if (animationConfig.autoplay) {
                autoplayTimer = setInterval(
                    nextSlide,
                    animationConfig.autoplayInterval
                );
            }
        }

        $container.find(".carousel-next").on("click", nextSlide);
        $container.find(".carousel-prev").on("click", prevSlide);

        // Autoplay handling
        startAutoplay();
        $container.on("mouseenter touchstart", () => clearInterval(autoplayTimer));
        $container.on("mouseleave touchend", startAutoplay);

        // Touch support (Hammer.js)
        const hammer = new Hammer($container[0]);
        hammer.on("swipeleft", nextSlide);
        hammer.on("swiperight", prevSlide);
    }

    // Public API
    return {
        initCarousel,
        setCarouselAnimation
    };
})();
